import { useState, useEffect, Fragment } from 'react';
import RssSubscriptionTool from '../components/rss/RssSubscriptionTool';

function RssSubscription() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    useEffect(() => {
        // Check if user is authenticated
        const token = localStorage.getItem('token');
        if (!token) {
            window.location.href = '/auth';
            return;
        }
        setIsAuthenticated(true);
    }, []);
    try {

        if (!isAuthenticated) {
            return null; // Will redirect in useEffect
        }

        return (
            <div className="container mx-auto px-4 py-8">
                <RssSubscriptionTool />
            </div>
        );
    } catch (error) {
        console.error('RssSubscription page error:', error);
        reportError(error);
        return null;
    }
}

export default RssSubscription;